import { jsx } from "react/jsx-runtime";
import { Box, FormField, Input, FormHelp, Label } from "@zillow/constellation";
import PropertySearch from "../../node_modules/@zillow/property-search/es/PropertySearch.esm.js";
import { useState } from "react";
import { useBlockEnvironment } from "../../contexts/BlockEnvironment/BlockEnvironmentProvider.esm.js";
const PROPERTY_SEARCH_CONFIG_VALUES = {
  prod: {
    addressAutocompleteURL: "https://www.zillowstatic.com/autocomplete/v3/suggestions/"
  },
  test: {
    addressAutocompleteURL: "https://static.qa.zillow.net/autocomplete/v3/suggestions/"
  }
};
const AddressAutocompleteField = ({
  onSelect,
  placeholder = "Enter the complete property address",
  label = "Property Address",
  description,
  required = false,
  error,
  onBlur
}) => {
  var _a;
  const {
    environment = "prod"
  } = useBlockEnvironment();
  const [address, setAddress] = useState("");
  const handleChange = (value) => {
    setAddress(value);
    onSelect(value);
  };
  const handleSubmit = (selection) => {
    const selectedAddress = (selection == null ? void 0 : selection.address) || address;
    const zpid = selection == null ? void 0 : selection.zpid;
    if (selectedAddress) {
      onSelect(selectedAddress, zpid);
    }
  };
  return /* @__PURE__ */ jsx(Box, { marginBottom: "$spacing.sm", children: /* @__PURE__ */ jsx(FormField, { error: Boolean(error), label: /* @__PURE__ */ jsx(Label, { children: label }), required, description: /* @__PURE__ */ jsx(FormHelp, { error: !!error, children: error || description }), control: /* @__PURE__ */ jsx(PropertySearch, { renderEmptyState: null, renderInput: (props) => {
    return /* @__PURE__ */ jsx(Input, { required, error: Boolean(error), placeholder, value: address, onChange: (e) => handleChange(e.target.value), onBlur: props.onBlur || onBlur, ...props });
  }, addressAutocompleteUrl: ((_a = PROPERTY_SEARCH_CONFIG_VALUES == null ? void 0 : PROPERTY_SEARCH_CONFIG_VALUES[environment]) == null ? void 0 : _a.addressAutocompleteURL) || PROPERTY_SEARCH_CONFIG_VALUES.prod.addressAutocompleteURL, onChange: handleChange, onSubmit: handleSubmit }) }) });
};
export {
  AddressAutocompleteField as default
};
